import { render, staticRenderFns } from "./updatedeductions.vue?vue&type=template&id=2ece8448"
import script from "./updatedeductions.vue?vue&type=script&lang=js"
export * from "./updatedeductions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports